import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GetSaleOrdersDto } from "../models/orders/getSaleOrdersDto";
import { GenericRequestDto } from "../models/generic-request.dto";

@Injectable({
  providedIn: "root",
})
export class OrdersListingService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  constructor(private _http: HttpClient) {}

  getAllSaleOrders(
    request: GenericRequestDto
  ): Observable<GenericResponseDto<GetSaleOrdersDto[]>> {
    return this._http.post<GenericResponseDto<GetSaleOrdersDto[]>>(
      this.saleOrderManagementBaseURL + "/GetSaleOrderInformationWithFilters",
      request
    );
  }
}
